// src/App.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Público
import Index from "./components/web/index";
import Contacto from "./components/web/contacto";
import Catalogo from "./components/web/catalogo";
import Cupones from "./components/web/cupones";
import PrivacyPolicy from "./components/web/PrivacyPolicy";

// Admin (layout + páginas)
import AdminLogin from "./components/paginas/Login"; // ← es tu login de ADMIN
import Home from "./components/ui/Home";             // LAYOUT admin (con <Outlet />)
import Ordenes from "./components/paginas/Ordenes";
import OrdenesWeb from "./components/paginas/OrdenesWeb";
import OrdenesHistorial from "./components/paginas/OrdenesHistorial";
import OrdenWebDetalle from "./components/paginas/OrdenWebDetalle";
import Productos from "./components/paginas/Productos";
import NuevoProducto from "./components/paginas/NuevoProducto";
import Usuarios from "./components/paginas/Usuarios";
import NuevoUsuario from "./components/paginas/NuevoUsuario";
import SolicitudesUsuarios from "./components/admin/SolicitudesUsuarios";
import RevisarOrden from "./components/paginas/RevisarOrden";
import EditarProducto from "./components/ui/EditarProducto";
import Configuraciones from "./components/paginas/Configuraciones";
import RutasDashboard from "./components/paginas/RutasDashboard";
import SolicitudesDistribuidor from "./components/admin/SolicitudesDistribuidor";
import CuponNuevo from "./components/admin/CuponNuevo";
import InventarioHistorial from "./components/paginas/InventarioHistorial";
import DashboardGeneral from "./components/paginas/DashboardGeneral";

// Auth
import { AuthProvider, useAuth } from "./auth/AuthContext";
import RequireAdmin from "./admin/RequireAdmin"; // ← nuevo guard que acepta todos los roles admin

// Guard simple para rutas web que requieren sesión (cupones)
function RequireWebAuth({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/catalogo" replace />;
}

// (Dashboard simple removido; usamos DashboardGeneral en /admin index)

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/" element={<Index />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/catalogo" element={<Catalogo />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* /cupones: requiere sesión del sitio web */}
        <Route
          path="/cupones"
          element={
            <RequireWebAuth>
              <Cupones />
            </RequireWebAuth>
          }
        />

        {/* Login de ADMIN (separado del login web) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        {/* Compatibilidad por si había enlaces viejos a /login */}
        <Route path="/login" element={<Navigate to="/admin/login" replace />} />

        {/* Admin: Home es el layout; todo lo de admin se pinta en su <Outlet /> */}
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <Home />
            </RequireAdmin>
          }
        >
          <Route index element={<DashboardGeneral />} />
          <Route path="productos" element={<Productos />} />
          <Route path="nuevo-producto" element={<NuevoProducto />} />
          <Route path="usuarios" element={<Usuarios />} />
          <Route path="nuevo-usuario" element={<NuevoUsuario />} />
          <Route path="solicitudes-usuarios" element={<SolicitudesUsuarios />} />
          <Route path="ordenes" element={<Ordenes />} />
          <Route path="orden/:id" element={<RevisarOrden />} />
          <Route path="ordenes-web" element={<OrdenesWeb />} />
          <Route path="ordenes-web/historial" element={<OrdenesHistorial />} />
          <Route path="ordenes-web/:id" element={<OrdenWebDetalle />} />
          <Route path="inventario/historial" element={<InventarioHistorial />} />
          <Route path="producto/:id" element={<EditarProducto />} />
          <Route path="rutas" element={<RutasDashboard />} />
          <Route path="configuraciones" element={<Configuraciones />} />
          <Route path="ascensos" element={<SolicitudesDistribuidor />} />
          <Route path="cupones" element={<CuponNuevo />} />
        </Route>

        {/* 404 → a catálogo */}
        <Route path="*" element={<Navigate to="/catalogo" replace />} />
      </Routes>
    </AuthProvider>
  );
}
